var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-template',{attrs:{"total":_vm.total,"table-data":_vm.tableData,"table-config":_vm.tableConfig,"has-back":""},on:{"onChangePage":_vm.changeCurrentPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }